<div class="w-full">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
    <div class="flex items-center gap-4">
      <button mat-icon-button (click)="goBack()" matTooltip="Wróć do listy">
        <mat-icon [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
      </button>
      <div>
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white">
          {{ isEdit ? 'Edytuj kampanię' : 'Nowa kampania' }}
        </h1>
        <p class="text-gray-500 dark:text-gray-400 text-sm mt-0.5">
          {{ isEdit ? campaign?.name : 'Utwórz nową kampanię newsletterową' }}
        </p>
      </div>
    </div>
    
    <div class="flex items-center gap-2">
      <button mat-stroked-button (click)="openFilterDialog()" [disabled]="!isEdit || isLoading">
        <mat-icon [svgIcon]="'tabler_outline:users'" class="mr-2"></mat-icon>
        Odbiorcy
        <span *ngIf="campaign?.stats?.totalRecipients" class="ml-1 text-primary-600">
          ({{ campaign?.stats?.totalRecipients }})
        </span>
      </button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving || form.invalid">
        <mat-icon *ngIf="isSaving" class="icn-spinner mr-2" [svgIcon]="'tabler_outline:loader'"></mat-icon>
        <mat-icon *ngIf="!isSaving" [svgIcon]="'tabler_outline:device-floppy'" class="mr-2"></mat-icon>
        {{ isEdit ? 'Zapisz zmiany' : 'Utwórz kampanię' }}
      </button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-20">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Content -->
  <div *ngIf="!isLoading" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    
    <!-- Left: Form -->
    <div class="bg-card rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
        <h2 class="font-semibold text-gray-900 dark:text-white flex items-center gap-2">
          <mat-icon [svgIcon]="'tabler_outline:settings'" class="!w-5 !h-5"></mat-icon>
          Ustawienia kampanii
        </h2>
      </div>
      
      <div class="p-6">
        <form [formGroup]="form" class="space-y-5">
          
          <!-- Basic info -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Nazwa kampanii</mat-label>
            <input matInput formControlName="name" placeholder="np. Newsletter Styczeń 2025">
            <mat-error *ngIf="form.controls['name'].hasError('required')">Nazwa jest wymagana</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Temat wiadomości</mat-label>
            <input matInput formControlName="subject" placeholder="np. Nowości w Fakturnia.pl!">
            <mat-error *ngIf="form.controls['subject'].hasError('required')">Temat jest wymagany</mat-error>
          </mat-form-field>

          <!-- Schedule -->
          <div class="flex items-center gap-3 mb-4">
            <mat-slide-toggle formControlName="sendImmediately" color="primary">
              Wyślij natychmiast po uruchomieniu
            </mat-slide-toggle>
          </div>
          
          <div *ngIf="!form.get('sendImmediately')?.value" class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Data rozpoczęcia</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="startDate">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Godzina</mat-label>
              <input matInput formControlName="startTime" type="time">
            </mat-form-field>
          </div>

          <!-- HTML Content -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Treść HTML</mat-label>
            <textarea matInput formControlName="htmlContent" rows="16" 
                      placeholder="Wklej tutaj kod HTML wiadomości..."></textarea>
            <mat-hint>Pixel trackingu i link wypisania zostaną dodane automatycznie</mat-hint>
          </mat-form-field>

        </form>

        <!-- Send test email -->
        <div *ngIf="isEdit" class="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
          <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
            <mat-icon [svgIcon]="'tabler_outline:send'" class="!w-4 !h-4"></mat-icon>
            Wyślij testową wiadomość
          </h3>
          <div class="flex gap-2">
            <mat-form-field appearance="outline" class="flex-1">
              <mat-label>Adres e-mail</mat-label>
              <input matInput [(ngModel)]="testSendEmail" placeholder="twoj@email.com" 
                     (keyup.enter)="sendTestEmail()">
            </mat-form-field>
            <button mat-flat-button color="primary" 
                    (click)="sendTestEmail()" 
                    [disabled]="isSendingTestEmail || !testSendEmail"
                    class="h-14">
              <mat-icon *ngIf="isSendingTestEmail" class="icn-spinner" [svgIcon]="'tabler_outline:loader'"></mat-icon>
              <mat-icon *ngIf="!isSendingTestEmail" [svgIcon]="'tabler_outline:send'"></mat-icon>
            </button>
          </div>
          <p class="text-xs text-gray-500 mt-1">Wyślij podgląd bez pixela i linku wypisania</p>
        </div>

        <!-- Add test recipient -->
        <div *ngIf="isEdit" class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
            <mat-icon [svgIcon]="'tabler_outline:user-plus'" class="!w-4 !h-4"></mat-icon>
            Dodaj odbiorcę do kampanii
          </h3>
          <div class="flex gap-2">
            <mat-form-field appearance="outline" class="flex-1">
              <mat-label>Adres e-mail</mat-label>
              <input matInput [(ngModel)]="testEmail" placeholder="test@example.com" 
                     (keyup.enter)="addTestRecipient()">
            </mat-form-field>
            <button mat-stroked-button 
                    (click)="addTestRecipient()" 
                    [disabled]="isAddingTestRecipient || !testEmail"
                    class="h-14">
              <mat-icon *ngIf="isAddingTestRecipient" class="icn-spinner" [svgIcon]="'tabler_outline:loader'"></mat-icon>
              <mat-icon *ngIf="!isAddingTestRecipient" [svgIcon]="'tabler_outline:plus'"></mat-icon>
            </button>
          </div>
          <p class="text-xs text-gray-500 mt-1">Dodaj odbiorcę do kolejki wysyłki kampanii</p>
        </div>
      </div>
    </div>

    <!-- Right: Preview -->
    <div class="bg-card rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden flex flex-col">
      <div class="p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex items-center justify-between">
        <h2 class="font-semibold text-gray-900 dark:text-white flex items-center gap-2">
          <mat-icon [svgIcon]="'tabler_outline:eye'" class="!w-5 !h-5"></mat-icon>
          Podgląd wiadomości
        </h2>
        <mat-spinner *ngIf="isLoadingPreview" diameter="20"></mat-spinner>
      </div>
      
      <div class="flex-1 p-4 overflow-auto bg-gray-100 dark:bg-gray-900">
        <!-- Email frame simulation -->
        <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden shadow-sm bg-white">
          <!-- Email header -->
          <div class="px-4 py-3 bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
            <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 mb-1">
              <span class="font-medium">Od:</span>
              <span>Fakturnia.pl &lt;kontakt&#64;fakturnia.pl&gt;</span>
            </div>
            <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 mb-1">
              <span class="font-medium">Do:</span>
              <span class="text-gray-400">odbiorca&#64;example.com</span>
            </div>
            <div class="flex items-center gap-2 text-sm">
              <span class="font-medium text-gray-500 dark:text-gray-400">Temat:</span>
              <span class="text-gray-900 dark:text-white font-medium">{{ form.get('subject')?.value || '(brak tematu)' }}</span>
            </div>
          </div>
          
          <!-- Email body - pełny szablon z backendu -->
          <div class="bg-white">
            <div *ngIf="previewHtml" [innerHTML]="previewHtml" class="email-preview"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
